import { graphql } from 'react-relay';

export type { ProjectRootQuery as ProjectRootQueryType } from './__generated__/ProjectRootQuery.graphql';

export const ProjectRootQuery = graphql`
    query ProjectRootQuery($projectId: String!, $loadPreview: Boolean = false) {
        viewer {
            ...InteriorProjectWrapper_viewer
        }
    }
`;
